import IcbTree from './interestedIndustries/treeComponent/IcbTree'
import VsicTree from './interestedIndustries/treeComponent/VsicTree'
import ForeignTree from './interestedLocation/treeComponent/ForeignTree'
import ProvinceTree from './interestedLocation/treeComponent/ProvinceTree'

const industriesContainerStyle = { height: 150, marginTop: 10 }
const tabsTreeStyle = { marginRight: 15 }
const locationsContainerStyle = { height: 100, marginTop: 10 }

export const TABS_KEY = {
  VSIC: 'VSIC',
  ICB: 'ICB',
}

export const getTabs = (vsics, icbs) => {
  return [
    {
      label: 'VSIC',
      key: TABS_KEY.VSIC,
      children: (
        <VsicTree
          vsics={vsics}
          customContainerStyle={industriesContainerStyle}
          customTreeStyle={tabsTreeStyle}
        />
      ),
    },
    {
      label: 'ICB',
      key: TABS_KEY.ICB,
      children: (
        <IcbTree
          icbs={icbs}
          customContainerStyle={industriesContainerStyle}
          customTreeStyle={tabsTreeStyle}
        />
      ),
    },
  ]
}

export const getTabsLocation = (cities, countries) => {
  return [
    {
      label: 'settingPreferences.VIETNAM_PROVINCES',
      key: 'province',
      children: (
        <ProvinceTree
          cities={cities}
          customContainerStyle={locationsContainerStyle}
        />
      ),
    },
    {
      label: 'settingPreferences.OTHER_COUNTRIES',
      key: 'foreignRegion',
      children: (
        <ForeignTree
          countries={countries}
          customContainerStyle={locationsContainerStyle}
        />
      ),
    },
  ]
}

export const getAppendStyleItem = (isActive) => ({
  width: '50%',
  height: '28px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: isActive ? '#2C73E8' : '#F3F3F3',
  color: isActive ? '#FFFFFF' : '#191D25',
  cursor: 'pointer',
  borderBottom: 'unset',
})
